import { render, staticRenderFns } from "./WkField.vue?vue&type=template&id=3f063b76&scoped=true"
import script from "./WkField.vue?vue&type=script&lang=js"
export * from "./WkField.vue?vue&type=script&lang=js"
import style0 from "./WkField.vue?vue&type=style&index=0&id=3f063b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f063b76",
  null
  
)

export default component.exports